/**
 * Ícones de linha do design "Bow Perfil e Indique" (Claude Design,
 * bow-perfil-indique.jsx) — mesmo peso do icon set do app (stroke ~1.8).
 * Todos `aria-hidden`; cor por prop ou `currentColor`.
 */

const ROYAL = '#001B74';
const GREEN = '#00C072';

/** Presente de linha — branco com laço verde (sobre o card aurora). */
export function GiftLine({ size = 66 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden className="shrink-0">
      <g stroke="#FFFFFF" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="18" width="36" height="24" rx="2.5" />
        <rect x="4" y="12" width="40" height="6.5" rx="2" />
        <path d="M24 12c-1.5-4-4-7.5-7.5-7.5A4 4 0 0 0 16 12" />
        <path d="M24 12c1.5-4 4-7.5 7.5-7.5A4 4 0 0 1 32 12" />
      </g>
      <path d="M20.5 12v30M27.5 12v30" stroke={GREEN} strokeWidth="1.9" />
    </svg>
  );
}

/** Duas pessoas — título "Seus indicados". */
export function PeopleLine({ size = 56 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden className="shrink-0">
      <g stroke={ROYAL} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="16" r="7" />
        <circle cx="34" cy="18" r="5.5" />
        <path d="M6 38c0-6.6 5.4-11 12-11" />
        <path d="M44 38c0-5.2-4-8.6-10-8.6" />
      </g>
      <path d="M18 27c6.6 0 12 4.4 12 11" stroke={GREEN} strokeWidth="1.9" strokeLinecap="round" />
    </svg>
  );
}

/** WhatsApp (preenchido, `currentColor`). */
export function WhatsGlyph({ size = 19 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden className="shrink-0">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.74.45 3.43 1.32 4.92L2 22l5.32-1.4a9.85 9.85 0 0 0 4.71 1.2c5.46 0 9.92-4.45 9.92-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2zm0 1.66c2.2 0 4.27.86 5.83 2.42a8.27 8.27 0 0 1 2.42 5.83c0 4.55-3.7 8.25-8.25 8.25-1.55 0-3.06-.43-4.36-1.24l-.31-.18-3.21.84.86-3.13-.21-.32a8.21 8.21 0 0 1-1.27-4.4c0-4.55 3.71-8.25 8.25-8.25zm-3.39 4.4c-.18 0-.47.07-.71.32-.23.25-.93.91-.93 2.21 0 1.3.95 2.56 1.08 2.74.13.18 1.86 2.84 4.5 3.95.62.27 1.11.43 1.49.55.62.2 1.18.17 1.63.1.5-.07 1.55-.63 1.77-1.24.22-.61.22-1.13.15-1.24-.07-.11-.25-.18-.52-.31-.27-.13-1.55-.76-1.79-.85-.24-.09-.41-.13-.59.13-.18.27-.68.85-.83 1.03-.15.18-.3.2-.57.07a7.34 7.34 0 0 1-2.16-1.33 8.05 8.05 0 0 1-1.49-1.85c-.16-.27-.02-.41.12-.55.12-.12.27-.31.4-.46.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.59-1.41-.81-1.94-.21-.51-.43-.43-.59-.44-.15 0-.33-.02-.51-.02z" />
    </svg>
  );
}

/** Escudo — "Privacidade e termos". */
export function ShieldLine({ size = 26 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={ROYAL}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="M12 3l7.5 3v6c0 4.6-3.1 8.2-7.5 9.5C7.6 20.2 4.5 16.6 4.5 12V6L12 3z" />
    </svg>
  );
}

/** Carteira — linha "Carteira" do Perfil (fecho verde). */
export function WalletLine({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden className="shrink-0">
      <g stroke={ROYAL} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h12A2.5 2.5 0 0 1 20 8.5V17a2.5 2.5 0 0 1-2.5 2.5h-12A2.5 2.5 0 0 1 3 17V8.5z" />
        <path d="M6.5 6V5A1.5 1.5 0 0 1 8 3.5h7.5" />
      </g>
      <path
        d="M16 12.2h4.5a1 1 0 0 1 1 1v1.6a1 1 0 0 1-1 1H16a1.8 1.8 0 0 1 0-3.6z"
        stroke={GREEN}
        strokeWidth="1.7"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

/** Painel do parceiro — colunas de gráfico com a última em verde. */
export function ChartLine({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden className="shrink-0">
      <g stroke={ROYAL} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.5 20.5h17" />
        <path d="M6 20.5v-6M10.5 20.5v-10" />
      </g>
      <path d="M15 20.5V7.5M19 20.5V4" stroke={GREEN} strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

/** Notificações — sino de linha com o badalo em verde. */
export function BellLine({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden className="shrink-0">
      <path
        d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z"
        stroke={ROYAL}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 21h4" stroke={GREEN} strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

/** Sair — porta com seta (`currentColor`). */
export function LogoutLine({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="M14 4H6a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 6 20h8" />
      <path d="M18 12H9.5M15 8.5l3.5 3.5L15 15.5" />
    </svg>
  );
}

export function ArrowRightLine({ size = 19 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}

export function ArrowLeftLine({ size = 25 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="M19 12H5M11 6l-6 6 6 6" />
    </svg>
  );
}

export function ChevronRightLine({ size = 19 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

/**
 * Presente de linha do convite do INDICADO (Claude Design · bow-convite.jsx ·
 * CvGift): duas cores da marca — traço navy (ou branco sobre navy) + fita
 * verde; `sparks` acrescenta 3 faíscas no topo (landing).
 */
export function GiftOutline({
  size = 62,
  onDark = false,
  sparks = false
}: {
  size?: number;
  onDark?: boolean;
  sparks?: boolean;
}) {
  const stroke = onDark ? '#FFFFFF' : ROYAL;
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" aria-hidden className="shrink-0">
      {sparks && (
        <g
          stroke={onDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,27,116,0.3)'}
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M28 4v6" />
          <path d="M18 7.5l2.5 5" />
          <path d="M38 7.5l-2.5 5" />
        </g>
      )}
      <g stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="25" width="38" height="25" rx="2.5" />
        <rect x="7" y="18.5" width="42" height="7" rx="2" />
        <path d="M28 18.5c-1.6-4.3-4.2-8-8-8a4.2 4.2 0 0 0-.4 8" />
        <path d="M28 18.5c1.6-4.3 4.2-8 8-8a4.2 4.2 0 0 1 .4 8" />
      </g>
      <path d="M24.4 18.5V50M31.6 18.5V50" stroke={GREEN} strokeWidth="2" />
    </svg>
  );
}

/** Check pequeno (`currentColor`) — "Código X aplicado". */
export function CheckLine({ size = 11 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <path d="m5 12 5 5L20 7" />
    </svg>
  );
}
